module.exports = __webpack_public_path__ + "static/media/eezy.534e87ff.svg";